import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './store';
import installSessionInterceptors from './utils/sessionInterceptors';

// Installed before anything renders, so the very first request already
// picks up a refreshed token and routes a session-ended 401 correctly.
installSessionInterceptors(store);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.register();
